import React, { FC } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { AuthStatus } from 'state/auth/reducer';
import { authRoleSelector, authStatusSelector } from 'state/auth/selectors';
import { onboardingScreenSelector } from 'state/onboarding/selectors';

import { OnboardingScreen } from 'pages/Onboarding/types';

import { RoutePath } from 'RoutePath';

import { UserRole } from 'types';

export const VendorRegistrationRoute: FC<RouteProps> = props => {
    const status = useSelector(authStatusSelector);
    const screen = useSelector(onboardingScreenSelector);
    const role = useSelector(authRoleSelector);
    switch (status) {
        case AuthStatus.LOGGED_IN:
            if (screen && screen !== OnboardingScreen.SUCCESS) {
                return <Route {...props} />;
            }
            if (role === UserRole.CUSTOMER) {
                window.location.assign(RoutePath.FEED);
                return null;
            }
            return <Redirect to={RoutePath.VENDOR_DASHBOARD} />;
        case AuthStatus.GUEST:
            return <Route {...props} />;
        default:
            return null;
    }
};
